import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import { CandidateResume } from 'wisestep-api';
import {
  Item,
  WsColors,
  ControlledTextInput,
  Label,
  WsTypography,
  WsTypoVariants,
  WsFileUpload,
  WsTypoColors,
  WsButton,
} from 'wisestep-base';

import { RESUME_ACTIONS } from '../types/ResumeActionTypes';
import ResumeHeaderAndActions from '../utils/ResumeHeaderAndActions';

import MappingNotification from './MappingNotification';

const GridItem = styled(Item)(() => ({
  paddingTop: 0,
  paddingBottom: '10px',
}));

interface IPersonalInfo {
  candidate: any;
  showTitle?: boolean;
  purpose?: 'submission' | 'mapping';
  isCandidate: 'PRESENT' | 'NOT PRESENT' | 'UNDEFINED' | 'DUPLICATE';
  onUpload?: (args: File[]) => void;
  resumeAction: (args1: RESUME_ACTIONS, args2: string, arg3?: string) => void;
}

const PersonalInfoNew: FC<IPersonalInfo> = ({ candidate, onUpload, resumeAction, isCandidate }) => {
  return (
    <Box m={3} p={3} borderRadius={1} bgcolor={WsColors.White}>
      <>
        <Box>
          <Box py={2}>
            <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.TERTIARY900} bold>
              Add Email To Proceed
            </WsTypography>
          </Box>
          <GridItem>
            <ControlledTextInput
              name="email"
              labelText="Email address *"
              type="email"
              fullWidth
              id="candidate_email"
              placeholder="Enter Candidate Email Address"
              variant="outlined"
              autoComplete="candidate_email"
              defaultValue={candidate?.email}
              disabled={isCandidate !== 'UNDEFINED'}
            />
          </GridItem>
          {isCandidate === 'UNDEFINED' && (
            <Grid item container gap={1} p={2}>
              <WsButton variant="outlined" size="large">
                Next
              </WsButton>
            </Grid>
          )}
          {isCandidate === 'DUPLICATE' && (
            <Grid py={2}>
              <MappingNotification variant="DUPLICATE" />
            </Grid>
          )}
        </Box>
        {candidate !== null && isCandidate === 'PRESENT' && (
          <Box py={2}>
            <MappingNotification variant="EXIST" />
            <Box pt={3} pb={1}>
              <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.TERTIARY900} bold>
                Candidate details
              </WsTypography>
            </Box>
            <Grid item p={2} columnGap={2} rowSpacing={2}>
              <Box>
                <WsTypography variant={WsTypoVariants.TITLE}>{`Name       :  ${
                  candidate.name ?? ''
                }`}</WsTypography>
              </Box>
              <Box py={2}>
                <WsTypography variant={WsTypoVariants.TITLE}>{`Ph No      :  ${
                  candidate.phoneNumber ?? ''
                }`}</WsTypography>
              </Box>
              <Box>
                {candidate.linkedInURL && (
                  <WsTypography variant={WsTypoVariants.TITLE}>{`linkedInURL :  ${
                    candidate.linkedInURL ?? ''
                  }`}</WsTypography>
                )}
              </Box>
            </Grid>
          </Box>
        )}
        {(isCandidate === 'NOT PRESENT' || (candidate !== null && isCandidate === 'PRESENT')) && (
          <Box py={2}>
            {isCandidate != 'PRESENT' && <MappingNotification variant="NEW" />}
            <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.TERTIARY900} bold>
              Upload CV for parsing
            </WsTypography>
            <GridItem>
              <Label>{isCandidate === 'NOT PRESENT' ? 'CV*' : 'CV'}</Label>
              {candidate?.mappedCandidateResumes?.map((resume: CandidateResume, index: number) => (
                <ResumeHeaderAndActions key={index} resume={resume} resumeAction={resumeAction} />
              ))}
              <WsFileUpload
                multiple={false}
                onUpload={(file: File[]) => onUpload && onUpload(file)}
                name="resume"
                placeholderText=" "
                bgRequired={false}
                buttonText={'Upload File'}
                maxFileSize={3}
              />
            </GridItem>
          </Box>
        )}
      </>
    </Box>
  );
};

export default PersonalInfoNew;
